module.exports = __webpack_public_path__ + "static/alex-ferguson-my-autobiography-35d96378e2c51176eb9b946e76283116.jpg";